import { createClient } from '@supabase/supabase-js';
import AsyncStorage from '@react-native-async-storage/async-storage';
import 'react-native-url-polyfill/auto';
import { EXPO_PUBLIC_SUPABASE_URL, EXPO_PUBLIC_SUPABASE_ANON_KEY } from '@env';

if (!EXPO_PUBLIC_SUPABASE_URL || !EXPO_PUBLIC_SUPABASE_ANON_KEY) {
  throw new Error('Supabase URL e Anon Key são obrigatórios. Configure o arquivo .env');
}

const supabaseUrl = EXPO_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = EXPO_PUBLIC_SUPABASE_ANON_KEY;

let supabase = null;

try {
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      storage: AsyncStorage,
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: false,
    },
  });
} catch (error) {
  console.error('Erro ao inicializar Supabase:', error.message);
  // Criar um cliente mock para desenvolvimento
  supabase = {
    auth: {
      signInWithPassword: async () => ({ data: null, error: new Error('Modo offline') }),
      signUp: async () => ({ data: null, error: new Error('Modo offline') }),
      resetPasswordForEmail: async () => ({ data: null, error: new Error('Modo offline') }),
    },
  };
}

export { supabase };